// extracted by mini-css-extract-plugin
export var actionButton = "_og-0";
export var actionMenuContainer = "_og-i";
export var bubble = "_og-2";
export var bubbleActionMenu = "_og-j";
export var bubbleContext = "_og-6";
export var bubbleItems = "_og-7";
export var customer = "_og-3";
export var divider = "_og-8";
export var fileList = "_og-9";
export var hiddenComment = "_og-o";
export var infoAbove = "_og-a";
export var internal = "_og-4";
export var lightActionButton = "_og-1";
export var link = "_og-b";
export var merchant = "_og-5";
export var message = "_og-c";
export var profilePicture = "_og-e";
export var quillToolbarContainer = "_og-f";
export var senderDate = "_og-g";
export var senderDateCustomer = "_og-h";
export var senderName = "_og-d";
export var time = "_og-k";
export var uploadedImage = "_og-l";
export var username = "_og-m";
export var xsmall = "_og-n";